module.exports = __webpack_public_path__ + "img/icon_5_76.6cbac01a.png";